import axios from '@/utils/http';

export default () => {
  return axios
    .get('/user/kyc_video')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
